export type TennisStatus = {
  sts?: string;
  c?: Record<string, unknown>;
  T1?: { n?: string };
  t1?: { n?: string };
  T1n?: string;
  T2?: { n?: string };
  t2?: { n?: string };
  T2n?: string;
};

export type SetEntry = {
  key: string;
  label: string;
  pair: [number, number];
};

export type PipeStatEntry = {
  label: string;
  home: string;
  away: string;
};

type CourtData = Record<string, unknown>;

export const ensurePair = (value: unknown): [number, number] => {
  if (Array.isArray(value) && value.length >= 2) {
    const home = Number(value[0]);
    const away = Number(value[1]);
    return [Number.isFinite(home) ? home : 0, Number.isFinite(away) ? away : 0];
  }

  if (typeof value === "string" && value.includes(":")) {
    const [homeRaw, awayRaw] = value.split(":");
    const home = Number(homeRaw);
    const away = Number(awayRaw);
    return [Number.isFinite(home) ? home : 0, Number.isFinite(away) ? away : 0];
  }

  return [0, 0];
};

export const parsePipeStats = (sts?: string): PipeStatEntry[] => {
  if (!sts || typeof sts !== "string") return [];

  return sts
    .split("|")
    .map((segment) => segment.trim())
    .filter(Boolean)
    .map((segment) => {
      const [rawLabel, values] = segment.split("=");
      if (!rawLabel || !values) return null;
      const [homeRaw, awayRaw] = values.split(":");
      if (homeRaw === undefined || awayRaw === undefined) return null;

      return {
        label: rawLabel.trim(),
        home: homeRaw.trim(),
        away: awayRaw.trim(),
      };
    })
    .filter((entry): entry is PipeStatEntry => !!entry);
};

export const extractSetEntries = (courtData: CourtData): SetEntry[] => {
  const keys = ["S1", "S2", "S3", "S4", "S5"];

  return keys
    .map((key, index) => {
      const pair = ensurePair((courtData as any)?.[key]);
      const hasScore = pair[0] !== 0 || pair[1] !== 0;

      if (!hasScore) return null;

      return {
        key,
        label: `Set ${index + 1}`,
        pair,
      };
    })
    .filter((entry): entry is SetEntry => !!entry);
};

export const extractTotals = (courtData: CourtData): [number, number] =>
  ensurePair((courtData as any)?.T);

export const extractPoints = (courtData: CourtData): [number, number] =>
  ensurePair((courtData as any)?.POINTS);
